import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
import FlexibleTable, {
    Header,
    Column,
} from 'components/charts/FlexibleTable/FlexibleTable';
import rotateColor from 'utilities/rotateColor';
import assetAllocationType from 'utilities/assetAllocationType';
import ColorSwatch from 'components/charts/ColorSwatch/ColorSwatch';
const { formatValue } = require('../utilities/valueFormater');

// <DataTable data={data} onMouseEnterRow={i => onMouseEnterRow && onMouseEnterRow(i)} returnIndex>
//     <DataTableColumn format={(_, i) => <ColorSwatch color={rotateColor(colors, i)} />} />
//     <DataTableColumn dataKey="type" format={assetAllocationType} />
//     <DataTableColumn dataKey="long" format={formatValuePercentage} header={formatText('fundsCard-long').toUpperCase()} />
//     <DataTableColumn dataKey="short" format={formatValuePercentage} header={formatText('fundsCard-short').toUpperCase()} />
//     <DataTableColumn dataKey="net" format={formatValuePercentage} header={formatText('fundsCard-net').toUpperCase()} />
//     <DataTableColumn dataKey="cat" format={formatValuePercentage} header={formatText('fundsCard-category').toUpperCase()} />
// </DataTable>

const formatValuePercentage = v => `${formatValue(v)}%`;

const AssetsAllocationsTableMobile = ({ colors, data, onRowClick }) => (
    <FlexibleTable
        data={data}
        onRowClick={i => onRowClick && onRowClick(i)}
        returnIndex
    >
        <Header
            format={(_, i) => <ColorSwatch color={rotateColor(colors, i)} />}
        />
        <Header dataKey="type" format={assetAllocationType} />
        <Column
            dataKey="long"
            format={formatValuePercentage}
            header={i18n.formatText('fundsCard-long').toUpperCase()}
        />
        <Column
            dataKey="short"
            format={formatValuePercentage}
            header={i18n.formatText('fundsCard-short').toUpperCase()}
        />
        <Column
            dataKey="net"
            format={formatValuePercentage}
            header={i18n.formatText('fundsCard-net').toUpperCase()}
        />
        <Column
            dataKey="cat"
            format={formatValuePercentage}
            header={i18n.formatText('fundsCard-category').toUpperCase()}
        />
    </FlexibleTable>
);

AssetsAllocationsTableMobile.propTypes = {
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    onRowClick: PropTypes.func,
};

export default AssetsAllocationsTableMobile;
